const GUIDE_DEFAULTS_STORAGE_KEY = 'editor-guide-defaults.v1'

type GuideDefaults = {
  showGuides: boolean
  showSmartGuides: boolean
  hasStoredValue: boolean
}

export function loadGuideDefaults(): GuideDefaults {
  const fallback: GuideDefaults = {
    showGuides: true,
    showSmartGuides: true,
    hasStoredValue: false,
  }

  if (typeof window === 'undefined') return fallback

  try {
    const raw = window.localStorage.getItem(GUIDE_DEFAULTS_STORAGE_KEY)

    if (!raw) return fallback
    const parsed = JSON.parse(raw) as Partial<GuideDefaults & { snapToGuides?: boolean }>

    return {
      showGuides: typeof parsed.showGuides === 'boolean' ? parsed.showGuides : true,
      showSmartGuides: typeof parsed.showSmartGuides === 'boolean' ? parsed.showSmartGuides : true,
      hasStoredValue: true,
    }
  } catch {
    return fallback
  }
}

export function persistGuideDefaultsToStorage(defaults: {
  showGuides: boolean
  showSmartGuides?: boolean
}): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(GUIDE_DEFAULTS_STORAGE_KEY, JSON.stringify(defaults))
  } catch {
    // Ignore local persistence failures.
  }
}
